/**
 * Delivery-job status colours and the stops of the mini route (#2588).
 *
 * Pure data, so any feature can import it: it lives in `src/lib/` because the
 * `@features/dispatch` barrel pulls in `jobResource` (and with it `http`), and a
 * feature may only reach another feature through its barrel.
 */
import type { FulfillmentJob } from '@/services';

export type JobStatus = FulfillmentJob['status'];

/** The four stops of the delivery-job mini route, in order. Exception and cancelled are off the route. */
export const JOB_ROUTE_STOPS = [
  'planned',
  'dispatched',
  'in_progress',
  'completed',
] as const satisfies readonly JobStatus[];

/** Status colour per delivery-job status (ADR-0043 §3): dots, rings and lines only, never text. */
export const JOB_STATUS_TONE = {
  planned: { dot: 'bg-status-unassigned', ring: 'border-status-unassigned' },
  dispatched: { dot: 'bg-status-assigned', ring: 'border-status-assigned' },
  in_progress: { dot: 'bg-status-in-progress', ring: 'border-status-in-progress' },
  completed: { dot: 'bg-success', ring: 'border-success' },
  exception: { dot: 'bg-destructive', ring: 'border-destructive' },
  cancelled: { dot: 'bg-destructive', ring: 'border-destructive' },
} as const satisfies Record<JobStatus, { dot: string; ring: string }>;
